module.exports = __webpack_public_path__ + "static/media/12UNCTAD20.02d7a11e.jpg";